import clsx from 'clsx';

import type { ContractStatus } from '../api/client';

const STYLES: Record<ContractStatus, string> = {
  draft: 'bg-slate-100 text-slate-700',
  sent: 'bg-blue-100 text-blue-700',
  viewed: 'bg-indigo-100 text-indigo-700',
  signed: 'bg-emerald-100 text-emerald-700',
  declined: 'bg-orange-100 text-orange-700',
  void: 'bg-red-100 text-red-700',
  completed: 'bg-teal-100 text-teal-700',
};

export function StatusBadge({ status }: { status: ContractStatus | string }) {
  const cls = STYLES[status as ContractStatus] ?? 'bg-slate-100 text-slate-700';
  return <span className={clsx('badge', cls)}>{status}</span>;
}

/** Generic active/suspended badge for tenants. */
export function TenantStatusBadge({ status }: { status: 'active' | 'suspended' }) {
  const cls =
    status === 'active' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700';
  return <span className={clsx('badge', cls)}>{status}</span>;
}
